import './../products/products.scss'
import { RedoOutlined, ShoppingCartOutlined, CalendarOutlined } from '@ant-design/icons';
import React, { useDeferredValue, useEffect, useMemo, useState } from 'react';
import { Button, Popover, Modal, Tabs } from 'antd';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import config from '../../config';
import VenteClientDetail from './venteClientDetail/VenteClientDetail';
import { useSelector } from 'react-redux';
import Ticket from './ticket/Ticket';
import VentesJour from './VentesJour';
import VenteView from './venteView/VenteView';
import CountUp from 'react-countup';
import moment from 'moment';
import { toast } from 'react-toastify';
import canSeeFinance from '../../utils/canSeeFinance';
import {
  NdoePage, NdoePageHeader, NdoeToolbar, NdoeActionButton,
  NdoeResponsiveTable, NdoeStats, NdoeStatCard, NdoeRecherche, useIsDesktop,
} from '../../components/ndoe';
import { buildVenteColumns, buildVenteCardRenderer, venteSearchFilter } from './venteShared';

const Ventes = () => {
    const DOMAIN = config.REACT_APP_SERVER_DOMAIN;
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const startDate = queryParams.get('start_date');
    const endDate = queryParams.get('end_date');
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    // Recherche unifiée (16/07) : UNE zone libre + des facettes d'affinage, à la
    // place du bouton « Filtres avancés » qui dépliait VenteSelect. C'est ce
    // motif — un bouton « avancé » qui cache la période, alors que les critères
    // sont ailleurs — qui a égaré le proprio sur la liste des commandes.
    const [searchValue, setSearchValue] = useState('');
    // La période vient de l'URL au premier rendu (/ventes?start_date=…), puis
    // devient éditable dans le bloc de recherche.
    const [debut, setDebut] = useState(startDate || '');
    const [fin, setFin] = useState(endDate || '');
    const [livreurSel, setLivreurSel] = useState(null);
    const [marqueSel, setMarqueSel] = useState(null);
    // RECHERCHE CIBLÉE (31/07) — demande du propriétaire : garder la zone libre
    // et pouvoir contraindre chaque critère séparément, « avec une capacité
    // d'audit ». Une zone qui balaie tout répond à « je cherche quelque chose » ;
    // elle ne répond pas à « les ventes de CE livreur, sur CETTE marque,
    // au-dessus de CE montant » — et un audit doit pouvoir dire exactement ce
    // qu'il a demandé pour défendre le chiffre qu'il annonce.
    const [fCliente, setFCliente] = useState('');
    const [fArticle, setFArticle] = useState('');
    const [fRef, setFRef] = useState('');
    const [fTel, setFTel] = useState('');
    const [fPointure, setFPointure] = useState(null);
    const [fMin, setFMin] = useState('');
    const [fMax, setFMax] = useState('');
    const [open, setOpen] = useState(false);
    const [openVente, setOpenVente] = useState(false);
    const [iDcommande, setIdCommande] = useState('');
    const [idClient, setIdClient] = useState({});
    const [ticket, setTicket] = useState(false);
    const [idTicket, setIdTicket] = useState(false);
    const [recent, setRecent] = useState([]);
    const [pagination, setPagination] = useState({
          current: 1,
          pageSize: 10,
        });
    const isDesktop = useIsDesktop();
    // Mobile : la liste est rendue en cartes SANS pagination AntD — on limite
    // donc le rendu à un lot progressif (« Voir plus ») pour ne pas monter des
    // centaines de cartes d'un coup.
    const [mobileCount, setMobileCount] = useState(20);

    const user = useSelector((state) => state.user?.currentUser);

      // Refetch ciblé (remplace les window.location.reload qui perdaient
      // recherche, pagination et onglet à chaque suppression/rafraîchissement).
      // Le bloc de statistiques d'en-tête (venteRecentMarque) est resynchronisé
      // dans le même geste — l'ancien reload complet le faisait implicitement
      // (constat revue #99).
      const fetchRecent = async () => {
        try {
          const { data } = await axios.get(`${DOMAIN}/api/rapport/rapport/venteRecentMarque`);
          setRecent(data);
        } catch (error) {
          console.log(error);
        }
      };

      // Les dates sont passées explicitement : l'effet d'URL ci-dessous appelle
      // fetchVentes AVANT que le setDebut/setFin correspondant ne soit visible
      // dans cette closure. Sans ça, un lien /ventes?start_date=… chargerait la
      // période précédente.
      // Une borne vide n'est tout simplement pas envoyée (le serveur ne filtre
      // alors pas dessus) — l'ancienne URL envoyait la chaîne « null », que le
      // contrôleur ignorait explicitement : même résultat, sans le bricolage.
      const fetchVentes = async (d = debut, f = fin) => {
        setLoading(true);
        try {
          const params = {};
          if (d) params.start_date = d;
          if (f) params.end_date = f;
          const { data } = await axios.get(`${DOMAIN}/api/vente`, { params });
          setData(data);
        } catch (error) {
          console.log(error);
        } finally {
          setLoading(false);
        }
        fetchRecent();
      };

      const handleDelete = async (id) => {
        try {
          await axios.delete(`${DOMAIN}/api/vente/${id}`);
          fetchVentes();
          toast.success('Vente supprimée');
        } catch (err) {
          toast.error("Échec de la suppression de la vente");
        }
      };

      const HandVenteOpen = (e) => {
        setOpenVente(!openVente);
        setIdCommande(e)
      };

      const Rafraichir = () =>{
        fetchVentes();
      }

      // L'URL fait foi au chargement et à chaque changement de lien entrant.
      useEffect(() => {
        const d = startDate || '';
        const f = endDate || '';
        setDebut(d);
        setFin(f);
        fetchVentes(d, f);
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [DOMAIN, startDate, endDate]);

      // Une nouvelle recherche OU un nouveau jeu de données (refetch, nouvelle
      // période) repart du haut de la liste mobile.
      useEffect(() => { setMobileCount(20); }, [searchValue, livreurSel, marqueSel, data]);

    const handleOk = async (e) => {
      setOpen(true)
      setIdClient(e)
    };

    const handleTicket = async (e) => {
      setTicket(true)
      setIdTicket(e)
    };

  // Colonnes + carte mobile partagées avec l'onglet « Ventes du jour »
  // (définies dans venteShared.jsx — y compris la photo au survol ≥ 1 s).
  const columns = buildVenteColumns({
    user,
    onOpenClient: handleOk,
    onOpenVente: HandVenteOpen,
    onTicket: handleTicket,
    onDelete: handleDelete,
  });
  const renderVenteCard = buildVenteCardRenderer({
    user,
    canFinance: canSeeFinance(user),
    onOpenVente: HandVenteOpen,
    onTicket: handleTicket,
    onDelete: handleDelete,
  });

  // Options des facettes construites depuis les données reçues (dédoublonnées) :
  // zéro appel supplémentaire, et elles collent toujours à la période affichée.
  const livreurOptions = useMemo(() => {
    const vus = new Set((data || []).map((r) => r.username).filter(Boolean));
    return [...vus].sort().map((v) => ({ value: v, label: v }));
  }, [data]);
  const marqueOptions = useMemo(() => {
    const vus = new Set((data || []).map((r) => r.nom_marque).filter(Boolean));
    return [...vus].sort().map((v) => ({ value: v, label: v }));
  }, [data]);

  const pointureOptions = useMemo(() => {
    const vus = new Set((data || []).map((r) => r.pointure).filter((v) => v != null && v !== ''));
    return [...vus].sort((a, b) => Number(a) - Number(b)).map((v) => ({ value: String(v), label: `P${v}` }));
  }, [data]);

  // Un champ ciblé cherche DANS SON champ, et seulement lui — c'est tout
  // l'intérêt par rapport à la zone libre. Comparaison insensible à la casse et
  // aux accents (« MUSHIYA » doit trouver « Mushiya »).
  const norm = (v) => String(v ?? '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
  const contient = (valeurChamp, saisie) => !norm(saisie) || norm(valeurChamp).includes(norm(saisie));

  // ⚠ Le filtrage traverse plus de mille lignes et re-rend la table ENTIÈRE.
  // Fait à chaque frappe, la saisie devient collante (constaté ici même : le
  // navigateur ne rendait plus la main). `useDeferredValue` garde la frappe
  // fluide et laisse la liste rattraper son retard — c'est la liste qui attend,
  // pas le doigt. La zone libre en profite aussi : elle avait le même défaut.
  const qLent = useDeferredValue(searchValue);
  const clienteLent = useDeferredValue(fCliente);
  const articleLent = useDeferredValue(fArticle);
  const refLent = useDeferredValue(fRef);
  const telLent = useDeferredValue(fTel);
  const minLent = useDeferredValue(fMin);
  const maxLent = useDeferredValue(fMax);

  const filtreLibre = venteSearchFilter(qLent);
  const filteredData = useMemo(() => (data || []).filter((item) => {
    if (!filtreLibre(item)) return false;
    if (livreurSel && item.username !== livreurSel) return false;
    if (marqueSel && item.nom_marque !== marqueSel) return false;
    if (!contient(item.nom_client, clienteLent)) return false;
    if (!contient(item.nom_produit, articleLent)) return false;
    // La référence peut être celle de la VARIANTE ou celle du MODÈLE : on
    // accepte les deux, sinon un code lu sur une étiquette ne trouve rien.
    if (norm(refLent) && !(contient(item.code_article, refLent) || contient(item.code_produit, refLent))) return false;
    // Le téléphone se compare CHIFFRES SEULS : la base contient « +243 81… »,
    // « 081… », avec ou sans espaces — une comparaison littérale échouerait.
    const telChiffres = String(telLent).replace(/\D/g, '');
    if (telChiffres && !String(item.telephone ?? '').replace(/\D/g, '').includes(telChiffres)) return false;
    if (fPointure && String(item.pointure) !== String(fPointure)) return false;
    const montant = Number(item.total_prix_vente) || 0;
    if (minLent !== '' && montant < Number(minLent)) return false;
    if (maxLent !== '' && montant > Number(maxLent)) return false;
    return true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }), [data, qLent, livreurSel, marqueSel, clienteLent, articleLent, refLent, telLent, fPointure, minLent, maxLent]);
  const visibleData = isDesktop ? filteredData : filteredData?.slice(0, mobileCount);
  const resteMobile = (filteredData?.length || 0) - mobileCount;

  const nbFiltresActifs = [
    searchValue, livreurSel, marqueSel,
    fCliente, fArticle, fRef, fTel, fPointure, fMin, fMax,
  ].filter((v) => v != null && v !== '').length;
  const effacer = () => {
    setSearchValue(''); setLivreurSel(null); setMarqueSel(null);
    setFCliente(''); setFArticle(''); setFRef(''); setFTel('');
    setFPointure(null); setFMin(''); setFMax('');
  };

  // Ce que la recherche a RÉELLEMENT demandé, en clair. Un audit doit pouvoir
  // relire ses critères pour défendre le chiffre qu'il annonce — un compteur
  // « 7 filtres actifs » ne le permet pas.
  const criteres = [
    searchValue && `« ${searchValue} »`,
    fCliente && `cliente ~ ${fCliente}`,
    fArticle && `article ~ ${fArticle}`,
    fRef && `réf ~ ${fRef}`,
    fTel && `tél ~ ${fTel}`,
    fPointure && `pointure P${fPointure}`,
    livreurSel && `livreur ${livreurSel}`,
    marqueSel && `marque ${marqueSel}`,
    (fMin !== '' || fMax !== '') && `montant ${fMin !== '' ? `≥ ${fMin} $` : ''}${fMin !== '' && fMax !== '' ? ' et ' : ''}${fMax !== '' ? `≤ ${fMax} $` : ''}`,
  ].filter(Boolean);
  // Total de la sélection : le chiffre qu'on vient chercher quand on croise
  // des critères. Sans lui, il faudrait additionner les lignes à la main.
  const totalSelection = filteredData.reduce((s, v) => s + (Number(v.total_prix_vente) || 0), 0);

  // ----- Onglet "Ventes" -----
  const tabVentes = (
    <>
      {/* RECHERCHE UNIFIÉE (16/07) — même bloc que les commandes et les
          réceptions, pour que la recherche s'apprenne UNE fois. Remplace le
          champ de recherche étroit ET le bouton « Filtres avancés » (qui ne
          cachait qu'une plage de dates, alors que son nom promettait bien plus). */}
      <NdoeRecherche
        q={searchValue}
        onQ={setSearchValue}
        // Le placeholder ÉNUMÈRE ce que le champ couvre : sans ça, personne ne
        // devine qu'on peut y taper une marque ou une pointure.
        placeholder="Rechercher : client, article, code, livreur, marque, pointure… (plusieurs mots possibles)"
        periode={{ debut, fin }}
        onPeriode={(d, f) => { setDebut(d); setFin(f); }}
        onChercher={() => fetchVentes()}
        chargement={loading}
        facettes={[
          { cle: 'livreur', placeholder: 'Livreur', options: livreurOptions, valeur: livreurSel, onChange: setLivreurSel, largeur: 150 },
          { cle: 'marque', placeholder: 'Marque', options: marqueOptions, valeur: marqueSel, onChange: setMarqueSel, largeur: 150 },
        ]}
        champs={[
          { cle: 'cliente', label: 'Cliente', valeur: fCliente, onChange: setFCliente, placeholder: 'Nom…' },
          { cle: 'article', label: 'Article', valeur: fArticle, onChange: setFArticle, placeholder: 'Nom du modèle…' },
          { cle: 'ref', label: 'Référence', valeur: fRef, onChange: setFRef, placeholder: 'ESC-…' },
          { cle: 'tel', label: 'Téléphone', valeur: fTel, onChange: setFTel, placeholder: '81 234…' },
          { cle: 'pointure', label: 'Pointure', type: 'liste', valeur: fPointure, onChange: setFPointure, options: pointureOptions, largeur: 110 },
          { cle: 'min', label: 'Montant min', type: 'nombre', valeur: fMin, onChange: setFMin, placeholder: '0', suffixe: '$', largeur: 120 },
          { cle: 'max', label: 'Montant max', type: 'nombre', valeur: fMax, onChange: setFMax, placeholder: '∞', suffixe: '$', largeur: 120 },
        ]}
        actifs={nbFiltresActifs}
        onEffacer={effacer}
        resume={(
          <>
            <b>{filteredData.length}</b>
            {filteredData.length !== (data?.length || 0) && <> sur {data?.length || 0}</>}
            &nbsp;vente{filteredData.length > 1 ? 's' : ''}
            {canSeeFinance(user) && <span>· total <b>{totalSelection.toLocaleString('fr-FR')} $</b></span>}
            {(debut || fin) && <span>· du {debut || '…'} au {fin || '…'}</span>}
            {/* Les critères en toutes lettres — c'est ce qui rend le chiffre
                défendable : on relit ce qu'on a demandé. */}
            {criteres.length > 0 && <span>· {criteres.join(' · ')}</span>}
          </>
        )}
      />

      <NdoeToolbar>
        <Popover content={'Actualiser cette page'}>
          <NdoeActionButton variant="secondary" icon={<RedoOutlined />} onClick={Rafraichir}>
            Actualiser
          </NdoeActionButton>
        </Popover>
      </NdoeToolbar>

      <NdoeResponsiveTable
        data={visibleData}
        columns={columns.filter((col) => col.key !== 'total_prix_vente' || canSeeFinance(user))}
        rowKey={(record, i) => record.id_vente ?? record.id_commande ?? i}
        loading={loading}
        scroll={{ x: 'max-content' }}
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '50', '100', '200', '300', '400', '500'],
          onChange: (page, pageSize) => {
            setPagination({ ...pagination, current: page, pageSize });
          },
        }}
        renderCard={renderVenteCard}
        mobilePager={resteMobile > 0 ? (
          <div style={{ display: 'flex', justifyContent: 'center', padding: '10px 0 20px' }}>
            <NdoeActionButton variant="secondary" onClick={() => setMobileCount((n) => n + 20)}>
              Voir plus ({resteMobile} restante{resteMobile > 1 ? 's' : ''})
            </NdoeActionButton>
          </div>
        ) : null}
        empty={{ icon: '🧾', title: 'Aucune vente', text: 'Ajustez la recherche ou les filtres.' }}
      />
    </>
  );

  const tabItems = [
    {
      key: "1",
      label: (
        <>
          <ShoppingCartOutlined />Ventes
        </>
      ),
      children: tabVentes,
    },
    {
      key: "2",
      label: (
        <>
          <CalendarOutlined />Ventes du jour
        </>
      ),
      children: <VentesJour />,
    },
  ];

  return (
    <NdoePage>
      <NdoePageHeader
        eyebrow="Commerce"
        title="Liste de ventes"
        subtitle="Gérez et suivez vos ventes"
      />

      {recent[0] && (
        <div style={{ display: 'flex', fontSize: '13px', marginBottom: '8px', fontWeight: 'bold' }}>
          {`Du ${moment(recent[0]?.date_plus_ancienne).format('DD-MM-YYYY')} au ${moment(recent[0]?.date_plus_recente).format('DD-MM-YYYY')}`}
        </div>
      )}

      <NdoeStats>
        <NdoeStatCard label="Articles vendus" value={<CountUp end={recent[0]?.nbre_article_vendue || 0} />} />
        <NdoeStatCard label="Client(e)s acheteur(s)" value={<CountUp end={recent[0]?.nbre_de_vente || 0} />} />
        <NdoeStatCard label="Commandes" value={<CountUp end={recent[0]?.nbre_commande || 0} />} />
        {canSeeFinance(user) && (
          <NdoeStatCard gold label="Montant total" value={<><CountUp end={recent[0]?.montant_total || 0} /> $</>} />
        )}
      </NdoeStats>

      <Tabs type="card" items={tabItems} />

      {/* Modales */}
      <Modal
        title="Information du client"
        centered
        open={open}
        onCancel={() => setOpen(false)}
        width={850}
        footer={[
          <Button key="annuler" onClick={() => setOpen(false)}>
            Annuler
          </Button>
        ]}
      >
        <VenteClientDetail idClients={idClient}/>
      </Modal>

      <Modal
        title="Ticket"
        centered
        open={ticket}
        onCancel={() => setTicket(false)}
        width={550}
        footer={[]}
      >
        <Ticket idTicket={idTicket}/>
      </Modal>

      <Modal
        title=""
        centered
        open={openVente}
        onCancel={() => setOpenVente(false)}
        width={1150}
        footer={[]}
      >
        <VenteView id={iDcommande}/>
      </Modal>
    </NdoePage>
  )
}

export default Ventes
